<template>
  <section class="h_13">
    <div class="title_container">
      <div class="title f-center-title">
        <div>Aicy 卡片</div>
        <div>一键展开更便捷</div>
      </div>
      <div class="des f-center-sub-title">
        无需进入应用，也能选歌听歌、查看车辆状态、调节座椅设置等，精简操作时的步骤
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="img_slider" ref="sliderContainer">
      <div class="alive_control" v-ia>
        <div
          v-for="(i, index) in controlList"
          :key="index"
          class="control_item"
          :class="index === activeIndex && 'control_item_active'"
          @click="controlClick(i.url, index)"
        >
          {{ i.title }}
        </div>
      </div>
      <div class="slider_container" v-ia>
        <div class="slider_size border_container_light">
          <slider
            ref="slider"
            v-model="activeIndex"
            :controlBtn="false"
            :indicators="false"
            :interval="3000"
            :autoplay="autoplay"
            :touch="false"
            stopOnHover
            height="100%"
            width="100%"
          >
            <slider-item v-for="(i, index) in controlList" :key="index">
              <m-img :src="i.url" class="slider_img" />
            </slider-item>
          </slider>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { domVisibleArea } from '@/utils'
export default {
  name: 'Weather',
  data() {
    return {
      activeIndex: 0,
      autoplay: false,
      controlList: [
        {
          title: '音乐推荐',
          url: require('@/v2/mobile/assets/image/h_13/0.jpg'),
        },
        {
          title: '座椅按摩',
          url: require('@/v2/mobile/assets/image/h_13/1.jpg'),
        },
        {
          title: '胎压',
          url: require('@/v2/mobile/assets/image/h_13/2.jpg'),
        },
        {
          title: '能耗',
          url: require('@/v2/mobile/assets/image/h_13/3.jpg'),
        },
      ],
    }
  },
  watch: {
    sliderActiveIndex(current) {
      this.$gsap.to(`.slider_indicators`, {
        width: 8,
        backgroundColor: '#00000024',
        duration: 0.5,
      })
      this.$gsap.to(`.slider_indicators_${current}`, {
        width: 34,
        backgroundColor: '#1368fb',
        duration: 0.5,
      })
    },
  },
  methods: {
    controlClick(url, index) {
      this.activeIndex = index
    },
  },

  mounted() {
    domVisibleArea(this.$refs.sliderContainer, 1, () => {
      this.autoplay = true
      setTimeout(() => {
        this.activeIndex = 1
      }, 3000)
    })
  },
}
</script>

<style lang="less" scoped>
.h_13 {
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  z-index: 87;
  margin-top: -5px;
  padding-bottom: 120px;
  .title_container {
    margin: 0 24px;
  }
  .title {
    padding-top: 100px;
    display: flex;
    flex-direction: column;
    width: max-content;
    line-height: 1.4;
    font-size: 34px;
    // 设置背景
    background: radial-gradient(
      120.01% 677.74% at 1.57% 10.13%,
      #2e63ca 0%,
      #91a8e4 100%
    );
    // 背景作用于字体上
    background-clip: text;
    // 字体透明
    color: transparent;
    font-weight: 700;
  }
  .des {
    margin: 20px 0;
    font-size: 16px;
    line-height: 1.6;
    color: #00000080;
    max-width: 100%;
    word-wrap: break-word;
  }
  .img_slider {
    width: 89%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 24px;
    width: calc(100% - 48px);
    .alive_control {
      border-radius: 2rem;
      background-color: #f4f4f5;
      height: max-content;
      display: flex;
      width: 100%;
      .control_item {
        cursor: pointer;
        margin: 0.15rem;
        font-size: 0.25rem;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: clamp(38px, 4.5vw, 44px);
        color: #00000080;
        text-align: center;
        flex: 1;
      }
      .control_item_active {
        color: black;
        font-weight: 600;
        background-color: white;
      }
    }
    .slider_container {
      margin-top: 24px;
      width: 100%;
      display: flex;
      justify-content: center;

      .slider_size {
        width: 100%;
        aspect-ratio: 1.6;
        border-radius: 12px;
        overflow: hidden;
      }

      .slider_img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
